import { Button, CircularProgress } from '@mui/material'
import type { ReactNode } from 'react'

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isPending?: boolean
  onClick?: () => void
  startIcon?: ReactNode
  children?: ReactNode
}

// TODO: There is now ui-sdk version for this
export const LoadingButton = (props: LoadingButtonProps) => {
  const { onClick, isPending, children, startIcon, ...rest } = props

  return (
    <Button
      startIcon={
        isPending ? (
          <CircularProgress
            size={16}
            sx={theme => ({
              color: theme.palette.action.disabled,
            })}
          />
        ) : (
          startIcon
        )
      }
      onClick={onClick}
      variant="contained"
      color="primary"
      disabled={isPending}
      {...rest}
    >
      {children}
    </Button>
  )
}
